export class UnknownStudentApiError extends Error {
	public originalError: any;

	constructor(error: any) {
		super('Unknown student api error occurred');
		this.name = 'UnknownStudentApiSignInError';
		this.originalError = error;
	}
}
